import { images as brandImages } from 'configureBrand'
import { assetsUrl } from 'helpers'

const images = Object.freeze({
  logo: `${assetsUrl}${brandImages.logo}`,
  brandLogo: `${assetsUrl}${brandImages.brandLogo}`,
  proxCard: `${assetsUrl}${brandImages.proxCard}`,
  brcCard: `${assetsUrl}${brandImages.brcCard}`,
  dcCard: `${assetsUrl}${brandImages.dcCard}`,
  offerBanner: `${assetsUrl}${brandImages.offerBanner}`,
  monthlyStatement: `${assetsUrl}${brandImages.monthlyStatement}`,
  welcomeLetter: `${assetsUrl}${brandImages.welcomeLetter}`,
  bannerDesktop: `${assetsUrl}${brandImages.banner.desktop}`,
  bannerMobile: `${assetsUrl}${brandImages.banner.mobile}`,
  bannerDesktopPlcc: `${assetsUrl}${brandImages.plccBanner?.desktop}`,
  bannerMobilePlcc: `${assetsUrl}${brandImages.plccBanner?.mobile}`,
  fileCircle: `${assetsUrl}/icons/fileCircle.png`,
  activity: `${assetsUrl}/icons/activity.svg`,
  emptyInbox: `${assetsUrl}/icons/emptyInbox.svg`,
  alarm: `${assetsUrl}/icons/alarm.svg`,
  pdf: `${assetsUrl}/icons/pdf.svg`,
  print: `${assetsUrl}/icons/print.svg`,
  card: `${assetsUrl}/icons/card.svg`,
  cardSwap: `${assetsUrl}/icons/cardSwap.svg`,
  trash: `${assetsUrl}/icons/trash.svg`,
  successTickMark: `${assetsUrl}/icons/successTickMark.svg`,
  placeHolder: `${assetsUrl}/icons/placeholder.png`,
  searchResults: `${assetsUrl}/icons/searchResults.svg`,
  autoPay: `${assetsUrl}/icons/autopay.svg`,
  oneTimePayment: `${assetsUrl}/icons/oneTimePayment.svg`,
  ssn: `${assetsUrl}/icons/secureaccount.png`,
  securityCode: `${assetsUrl}/icons/cardsecurity.png`,
  csr: `${assetsUrl}/icons/cardactivationcsr.svg`,
  cardActiveSuccess: `${assetsUrl}/icons/CVVSuccess.png`,
  cliRequestApproved: `${assetsUrl}/commercial/common/cli-approved-spot-illustration.png`,
  cliRequestInReview: `${assetsUrl}/commercial/common/cli-in-review-spot-illustration.png`,
  welcomeMatPhoneLaptop: `${assetsUrl}/commercial/common/phoneLaptop.svg`,
  welcomeMatFindInfo: `${assetsUrl}/commercial/common/findInfo.svg`,
  welcomeMatQueries: `${assetsUrl}/commercial/common/queries.svg`,
  cliManHoldingErrorMobile: `${assetsUrl}/commercial/common/cli-man_holding_error_mobile.svg`,
  cliManHoldingErrorDesktop: `${assetsUrl}/commercial/common/cli-man_holding_error_desktop.svg`,
  cardActivationBannerDesktop: `${assetsUrl}${brandImages.cardActivationBannerDesktop}`,
  cardActivationBannerMobile: `${assetsUrl}${brandImages.cardActivationBannerMobile}`,
  cardReissueBannerDesktop: `${assetsUrl}${brandImages.cardReissueDesktop}`,
  cardReissueBannerMobile1: `${assetsUrl}${brandImages.cardReissueMobile1}`,
  cardReissueBannerMobile2: `${assetsUrl}${brandImages.cardReissueMobile2}`
})

export default images
